import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e4665b2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "centerBox" }
const _hoisted_2 = { class: "financial-wrapper" }
const _hoisted_3 = { class: "detailContent" }
const _hoisted_4 = { class: "modal-remark-label" }
const _hoisted_5 = {
  key: 0,
  class: "xingxing"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "备注", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "modal-uploader-label" }, "附件上传", -1))

import { 
  NodeInfoApi,//获取工商变更节点信息
  businessWithDrawApi,//撤回工商变更
  businessApproveApi,//工商变更审批
  companyFlowApproveApi,//其他模块审批
  houseRentRecallApi,//房屋租赁撤回回传
  decproRecallApi,//装修、采购协议撤回回传,
 } from "@/api/businessChange";
import { RecallFlow } from "@/api/index";
import {  NodeItem } from "@/types/procss";
import { reactive,onMounted,ref,getCurrentInstance,onUnmounted} from "vue";
import { message } from "ant-design-vue";
import { useRoute,useRouter } from "vue-router";
import Image from "@/components/Image.vue"
import HeadTitle from "@/components/HeadTitle.vue";
import Approval from "@/components/Approval.vue";
import BusinessDetail from "./Detail/BusinessDetail.vue";
import AddressForm from "./Form/Address.vue"
import AddressDetail from "./Detail/AddressDetail.vue";
import HouseRent from "./Form/HouseRent.vue";//房屋租赁表单
import Decpro from "./Form/Decpro.vue"; //装修采购表单
import Resource from "./Form/Resource.vue"; //资料以及用印表单
import Seal from "./Form/Seal.vue" //印章证照刻制
import TaxAddress from "./Form/TaxAddress.vue";//税务迁址
import ButtonGroup from "@/components/ButtonGroup.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { proxy } = getCurrentInstance();
const router = useRouter();
const route = useRoute();
const { id ,traceId,ChangeCompanyId,StaffId} = route.query;
const currentData = ref<NodeItem>();
const preData = ref<NodeItem>();
const WorkFlowId = ref<number>(0);//节点id

const recallVisible = ref<boolean>(false); //撤回申请
const recallResume = ref<string>(""); //撤回理由

const reEdit = ref<boolean>(false); //是否点击重新发起标识
const refresh = ref<boolean>(false);
const preButton = ref<(string | number)[]>([]); //存储重新发起点击前按钮


const dialogType = ref<string>("");

//基本字段定义
const data = reactive({
  id:id,
  currentStep:0,//当前节点
  steps:[],
  infoSteps:[],//资料变更节点
  activeKey:'1101',//租赁合同
  activeKey1:'1201',//变更资料审核
  
  ApplicationInfo:{},
  nodeList:[],//节点详情
  actionButtons:[],
})


// 切换节点
const handleTabChange = async(index: number) => {
  // const idx = data.steps[index].Code
  isFrist.value = true
  const { Data } = await NodeInfoApi({
    ChangeCompanyId: ChangeCompanyId,
    TraceId:traceId,
    StaffId:StaffId?StaffId:'',
  });
  if(Data){
    reEdit.value = false
    data.currentStep = data.steps[index].Code
    data.nodeList = Data
    handeleNode()
  }
}
//子节点切换
const handleTabChange1 =(code:string)=>{
  isFrist.value = true
  data.actionButtons = preButton.value
  const index = data.steps.findIndex((item: NodeItem)=>item.Code == code)
  data.currentStep = data.steps[index].Code
  handeleNode()
  // handleTabChange(index)
}
//处理节点
const handeleNode = ()=>{
  let nodeIdx:number|string;
  if(data.currentStep == 9 || data.currentStep == 10){
    nodeIdx = data.currentStep 
  }else if(data.currentStep == 11){
    nodeIdx = data.activeKey
  }else if(data.currentStep == 12){
    nodeIdx = data.activeKey1
  }
  currentData.value = data.nodeList.find((item: NodeItem) => item.Code == nodeIdx)
  if (currentData.value?.IsOperation) {//当前节点可操作性
    //前置节点已完成
    preData.value = null;
  }else{
    preData.value = data.nodeList.find(((_item: NodeItem) => _item.Code == currentData.value?.PreConditionCode))
  }

}

//获取工商变更节点信息
const getNodeInfo = async ()=>{
  const { Data } = await NodeInfoApi({
    ChangeCompanyId: ChangeCompanyId,
    TraceId:traceId,
    StaffId:StaffId?StaffId:'',
  });
  if(Data){
    data.nodeList = Data
    data.steps = data.nodeList.filter((item: NodeItem)=>item.IsShow && item.Level ==1)//主节点
    data.infoSteps  = data.nodeList.filter((item: NodeItem)=>item.ParentCode == '12' && item.IsShow)//资料变更节点

    const IsAnchorPoint = data.nodeList.filter((item: NodeItem)=>item.IsAnchorPoint)[0]//资料变更节点
    data.currentStep = IsAnchorPoint?.ParentCode == 0?IsAnchorPoint?.Code:IsAnchorPoint?.ParentCode
  
    handeleNode()
  }
}
//按钮操作
const rejectedVisible = ref<boolean>(false); //通过/驳回弹窗
const rejectResume = ref<string>("");
const PageFiles = ref<
  {
    FileName: string;
    FileUrl: string;
  }[]
>([]);
const handleClick = async (buttonType: string | number) => {
  dialogType.value = buttonType
  if (buttonType == "101" || buttonType =='402' || buttonType=='502') {//101撤回申请402房屋撤回回传,502装修采购撤回回传
    //撤回申请
    recallVisible.value = true;
  } else if(buttonType == "102") {//重新发起
    if(data.currentStep == 9){
      router.push({
        path: "/change",
        query: {
          id: currentData.value?.BranchCompanyFlowId,
        },
      });
    }else{
      preButton.value = data.actionButtons
      data.actionButtons = ["-1", "-2"];
      reEdit.value = true;
    }
  } else if(buttonType == "-1"){//点击重新发起的返回
    reEdit.value = false
    data.actionButtons = preButton.value
  } else if(buttonType == '103' || buttonType =='105'){//通过
    rejectedVisible.value = true;
  } else if(buttonType == '104'){//驳回
    rejectedVisible.value = true;
  }
}


//添加驳回理由
const setRejectResume = async () => {
  // 判断是驳回还是通过
  if (dialogType.value == "103") {
    // 通过
    pass(1);
  } else if (dialogType.value == "104") {
    // 驳回
    if (!rejectResume.value) {
      message.error("请填写备注");
      return;
    }
    pass(2);
  }
};

//上传附件
const handleUpload = (file: File) => {
  if (!file) {
    PageFiles.value = [];
  } else {
    let obj ={
      ...file,
      FileUrl: file.Url,
      url: file.url,
      name: file.name,
    }
    PageFiles.value.push(obj)
  }
};
//关闭通过/驳回弹窗
const hiddenReject = () => {
  rejectedVisible.value = false;
  rejectResume.value = "";
  PageFiles.value = [];
};
//通过/驳回
const pass = async (Status: number) => {
  var method;
  let param = {
    Description: rejectResume.value,
    Status: Status, //1:通过 2: 驳回
    PageFiles: PageFiles.value,
  };
  if (data.currentStep == 9) {//工商变更
    method = businessApproveApi;
    param.id = id
  } else{
    method = companyFlowApproveApi;
    param.WorkflowId = WorkFlowId.value
  }

  const { Success } = await method(param);
  if (Success) {
    getRefresh()
    hiddenReject()
  } else {
    message.success(`${Status == 1 ? "提交失败" : "驳回失败"}`);
  }
};

//撤回申请
const submitRecallSiteSelectionApply = async () => {
  if (!recallResume.value) {
    message.error("请输入撤回理由");
    return;
  }
  let method;
  let param = {}
  if(dialogType.value =='402' || dialogType.value =='502'){
    param.Reason = recallResume.value
    param.BusinessFlowId = currentData.value?.BranchCompanyFlowId
    param.TraceId =traceId

    method = dialogType.value =='402'? houseRentRecallApi:decproRecallApi
  }else{
    if (data.currentStep == 9) {
      method = businessWithDrawApi;
      param.RecallReason = recallResume.value
      param.id =id
    } else{
      method = RecallFlow
      param.Description = recallResume.value
      param.id = currentData.value?.BranchCompanyFlowId
    }
  }
 
  //撤回
  const { Success, Message } = await method(param);
  if (Success) {
    message.success("已撤回审核");
    recallVisible.value = false;

    getRefresh()
    handleCancelResume();
  } else {
    message.error(Message || "撤回失败，请稍后重试");
    handleCancelResume();
  }
};


//刷新详情
const getRefresh = async()=>{
  let childRef = `child${data.currentStep}`
  if( data.currentStep == 9){
    await proxy.$refs[childRef].getDetail()
  }else{
    $bus.emit('getDetail',currentData.value?.BranchCompanyFlowId)
  }
  
  // refresh.value = !refresh.value;
}


const handleCancelResume = () => {
  recallResume.value = "";
  recallVisible.value = false;
};

//第一次进页面不需要刷新
const isFrist =  ref<boolean>(true);
const setButtonStatus = ({ buttons, flowId }) => {
  var arr = [];
  for (let i in buttons) {
    if(buttons[i] == '100' && (currentData.value.State > 1 )){
      buttons[i] = '-3'
    }
    arr.push(buttons[i]);
  }
  let actionButtonsList = ["90", ...arr];
  data.actionButtons = actionButtonsList
  WorkFlowId.value = flowId
  if(!isFrist.value){
    refresh.value =!refresh.value 
  }
  isFrist.value = false
  
};

const $bus = getCurrentInstance()?.appContext.config.globalProperties.$bus
onMounted(() => {
  getNodeInfo()
  $bus.on('getId', (type:number) => {
    currentData.value.BranchCompanyFlowId = type
    reEdit.value = false
  })
});

onUnmounted(()=>{
    $bus.off('getId')
  })

return (_ctx: any,_cache: any) => {
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BreadCrumb, { meteItems: ['工商变更', '提交申请'] }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HeadTitle, { title: "审批事项" }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_steps, {
          class: _normalizeClass(["common-steps", _unref(data).steps.findIndex((item) => item.Code == '10') ==-1?'w400':'']),
          current: _unref(data).currentStep,
          "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).currentStep) = $event)),
          onChange: handleTabChange,
          size: "small"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).steps, (item) => {
              return (_openBlock(), _createBlock(_component_a_step, {
                key: item.Code,
                title: item.Title,
                status: _unref(data).currentStep == item.Code ? 'process' : 'wait'
              }, null, 8, ["title", "status"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["current", "class"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_unref(data).currentStep == 9)
          ? (_openBlock(), _createBlock(BusinessDetail, {
              key: 0,
              ref: "child9",
              onChangeStatus: setButtonStatus
            }, null, 512))
          : _createCommentVNode("", true),
        (_unref(data).currentStep == 10)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (currentData.value?.BranchCompanyFlowId == 0 || reEdit.value)
                ? (_openBlock(), _createBlock(AddressForm, {
                    key: 0,
                    BranchCompanyFlowId: currentData.value?.BranchCompanyFlowId,
                    reEdit: reEdit.value,
                    onChangeStatus: setButtonStatus,
                    preData: preData.value
                  }, null, 8, ["BranchCompanyFlowId", "reEdit", "preData"]))
                : (_openBlock(), _createBlock(AddressDetail, {
                    key: 1,
                    ref: "child10",
                    BranchCompanyFlowId: currentData.value?.BranchCompanyFlowId,
                    onChangeStatus: setButtonStatus
                  }, null, 8, ["BranchCompanyFlowId"]))
            ], 64))
          : _createCommentVNode("", true),
        (_unref(data).currentStep == 11)
          ? (_openBlock(), _createBlock(_component_a_tabs, {
              key: 2,
              activeKey: _unref(data).activeKey,
              "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((_unref(data).activeKey) = $event)),
              onChange: _cache[2] || (_cache[2] = ()=>handleTabChange1('11'))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tab_pane, {
                  key: "1101",
                  tab: "房屋租赁等合同审核"
                }, {
                  default: _withCtx(() => [
                    (_unref(data).activeKey == '1101')
                      ? (_openBlock(), _createBlock(HouseRent, {
                          key: 0,
                          ref: "child1101",
                          BranchCompanyFlowId: currentData.value?.BranchCompanyFlowId,
                          reEdit: reEdit.value,
                          preData: preData.value,
                          onChangeStatus: setButtonStatus
                        }, null, 8, ["BranchCompanyFlowId", "reEdit", "preData"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "1102",
                  tab: "装修、采购协议审核"
                }, {
                  default: _withCtx(() => [
                    (_unref(data).activeKey == '1102')
                      ? (_openBlock(), _createBlock(Decpro, {
                          key: 0,
                          ref: "child1102",
                          BranchCompanyFlowId: currentData.value?.BranchCompanyFlowId,
                          reEdit: reEdit.value,
                          preData: preData.value,
                          onChangeStatus: setButtonStatus
                        }, null, 8, ["BranchCompanyFlowId", "reEdit", "preData"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["activeKey"]))
          : _createCommentVNode("", true),
        (_unref(data).currentStep == 12)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              (_unref(data).infoSteps.length > 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_a_tabs, {
                      activeKey: _unref(data).activeKey1,
                      "onUpdate:activeKey": _cache[3] || (_cache[3] = ($event: any) => ((_unref(data).activeKey1) = $event)),
                      onChange: _cache[4] || (_cache[4] = ()=>handleTabChange1('12'))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).infoSteps, (item) => {
                          return (_openBlock(), _createBlock(_component_a_tab_pane, {
                            key: item.Code,
                            tab: item.Title
                          }, null, 8, ["tab"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["activeKey"]),
                    (_unref(data).activeKey1 == '1201')
                      ? (_openBlock(), _createBlock(Resource, {
                          key: 0,
                          ref: "child1201",
                          BranchCompanyFlowId: currentData.value?.BranchCompanyFlowId,
                          preData: preData.value,
                          reEdit: reEdit.value,
                          onChangeStatus: setButtonStatus
                        }, null, 8, ["BranchCompanyFlowId", "preData", "reEdit"]))
                      : _createCommentVNode("", true),
                    (_unref(data).activeKey1 == '1202')
                      ? (_openBlock(), _createBlock(TaxAddress, {
                          key: 1,
                          ref: "child1202",
                          BranchCompanyFlowId: currentData.value?.BranchCompanyFlowId,
                          preData: preData.value,
                          reEdit: reEdit.value,
                          onChangeStatus: setButtonStatus
                        }, null, 8, ["BranchCompanyFlowId", "preData", "reEdit"]))
                      : _createCommentVNode("", true),
                    (_unref(data).activeKey1 == '1203')
                      ? (_openBlock(), _createBlock(Seal, {
                          key: 2,
                          ref: "child1203",
                          BranchCompanyFlowId: currentData.value?.BranchCompanyFlowId,
                          preData: preData.value,
                          reEdit: reEdit.value,
                          onChangeStatus: setButtonStatus
                        }, null, 8, ["BranchCompanyFlowId", "preData", "reEdit"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(HeadTitle, { title: "资料及用印" }),
                    _createVNode(Resource, {
                      ref: "child1201",
                      BranchCompanyFlowId: currentData.value?.BranchCompanyFlowId,
                      preData: preData.value,
                      reEdit: reEdit.value,
                      onChangeStatus: setButtonStatus
                    }, null, 8, ["BranchCompanyFlowId", "preData", "reEdit"])
                  ], 64))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      (!_unref(data).actionButtons.includes('100') && !_unref(data).actionButtons.includes('-2') && currentData.value?.BranchCompanyFlowId !=0 )
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(HeadTitle, { title: "审批流程" }),
            _createVNode(Approval, {
              id: WorkFlowId.value,
              refresh: refresh.value,
              BranchCompanyFlowId: currentData.value?.BranchCompanyFlowId
            }, null, 8, ["id", "refresh", "BranchCompanyFlowId"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_unref(data).actionButtons.length > 0)
      ? (_openBlock(), _createBlock(ButtonGroup, {
          key: 0,
          "type-list": _unref(data).actionButtons,
          onClick: handleClick,
          "show-tips": 
        preData.value && preData.value.Title
          ? `提示：完成${preData.value.Title}审批后方可申请该模块`
          : ''
      ,
          isBottom: _unref(data).currentStep ==9 || _unref(data).currentStep ==10?true:false
        }, null, 8, ["type-list", "show-tips", "isBottom"]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      class: "modal-dialog",
      bodyStyle: {
      width: '460px',
      height: '216px',
    },
      visible: recallVisible.value,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((recallVisible).value = $event)),
      title: "撤回理由",
      onOk: submitRecallSiteSelectionApply,
      onCancel: handleCancelResume
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_textarea, {
          style: {"padding-left":"0"},
          value: recallResume.value,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((recallResume).value = $event)),
          bordered: false,
          placeholder: "请填写撤回理由",
          maxlength: 100,
          "auto-size": { minRows: 5, maxRows: 5 }
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      class: "modal-dialog",
      visible: rejectedVisible.value,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((rejectedVisible).value = $event)),
      title: 
      dialogType.value == '104' ? '驳回意见' : dialogType.value == '103' ? '通过意见' : ''
    ,
      onOk: setRejectResume,
      onCancel: hiddenReject
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          (dialogType.value == '104')
            ? (_openBlock(), _createElementBlock("i", _hoisted_5, "*"))
            : _createCommentVNode("", true),
          _hoisted_6
        ]),
        _createVNode(_component_a_textarea, {
          value: rejectResume.value,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((rejectResume).value = $event)),
          placeholder: "请填写",
          maxlength: 1000,
          "auto-size": { minRows: 5, maxRows: 5 }
        }, null, 8, ["value"]),
        _hoisted_7,
        _createVNode(Image, {
          value: PageFiles.value.length && PageFiles.value[0].FileUrl,
          "disable-close": false,
          disable: false,
          "file-type": '931',
          onUpload: handleUpload
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}
}

})